import "../../pages/index.css";

export default function MoreCaseStudies() {
  const caseStudies = [
    {
      id: 1,
      imageSrc: require("../../assets/img/casestudy1.jpg"), // Replace with actual image URL
      altText: "Case Study 1",
      title:
        "National Pipe Manufacturer Optimizes Operations with Salesforce Solutions.",
      link: "#",
    },
    {
      id: 2,
      imageSrc: require("../../assets/img/casestudy1.jpg"), // Replace with actual image URL
      altText: "Case Study 2",
      title:
        "National Level Cycle Manufacturer improves Sales and Operations Management.",
      link: "#",
    },
    {
      id: 3,
      imageSrc: require("../../assets/img/casestudy1.jpg"), // Replace with actual image URL
      altText: "Case Study 3",
      title:
        "National Pipe Manufacturer Optimizes Operations with Salesforce Solutions.",
      link: "#",
    },
  ];

  return (
    <div className="bg-white px-12 py-12" id="more-case-studies">
      <h2 className="text-3xl font-semibold text-gray-900 mb-6 px-4">
        More <span className="text-[#00A1E0]">Case Studies</span>
      </h2>
      <div className="grid gap-6 md:grid-cols-3">
        {caseStudies.map((study) => (
          <div
            key={study.id}
            className="flex flex-col bg-white rounded-lg overflow-hidden px-4 bg-red-500"
          >
            <img
              src={study.imageSrc}
              alt={study.altText}
              className="w-full h-50 object-cover"
            />
            <div className="learn-more py-4 text-start">
              <h3 className="text-2xl font-medium hover:text-[#0D4282] mb-2 hover:d-none">
                {study.title}
              </h3>
              <div className="learn-more-anime" style={{ maxWidth: "145px" }}>
                <a className="learn-more" href="ups.php">
                  <span className="circle-learn-more" aria-hidden="true">
                    <span className="icon-learn-more arrow-learn-more"></span>
                  </span>
                  <span
                    className="button-text"
                    style={{
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "400",
                    }}
                  >
                    Read More
                  </span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
